import React, { PropTypes } from 'react';
import LightBox from '../Common/LightBox';

export default class MultimidiaModal extends React.Component { 

	render() {
		const { videoID, isOpen, onClose } = this.props;
		const lightBoxStyle = {
			overlay: {
				backgroundColor: 'rgba(50, 50, 50, 0.75)'
			},
			content: {
				padding: '0',
				paddingBottom: "0",
				background: 'transparent'
			}
		};

		return (
			<LightBox
				isOpen={isOpen}
				onClose={onClose}
				style={lightBoxStyle}
				>
				<div className="video-responsive">
					<iframe
						width="718px"
						height="412px"
						src={`https://www.youtube.com/embed/${videoID}`}
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
						title="Embedded youtube"
					/>
				</div>
			</LightBox>
		);
	}

}

MultimidiaModal.propTypes = {
	videoID: PropTypes.string.isRequired,
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Multimidia/MultimidiaModal.js